"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.library.empty': 'No posts yet',
    'socialMediaPlan.library.emptyDesc': 'Create your first post with the wizard.',
    'socialMediaPlan.library.contains_errors': 'This post contains publishing errors',
};
